import {
    ExternalApplicationRequest,
    DeliveryMethod,
    SubmittingUser,
} from '@servicetitan/financing-api-client';
import {
    Citizenship,
    EmploymentStatus,
    LoanApplicationSubmitSource,
    PropertyType,
    ResidenceOwnership,
    ResidenceType,
    SpokenLanguage,
    StartExternalPrequalWithoutLinkRequest,
} from '@servicetitan/financing-api-client/src/prequals-api';

export const mapExternalApplicationToBuyFinPrequal = (
    externalApp: ExternalApplicationRequest,
    submittingUser?: SubmittingUser,
): StartExternalPrequalWithoutLinkRequest => {
    return {
        providerName: 'General',
        generalProviderName: 'BuyFin',
        customerId: externalApp.customerId,
        jobId: externalApp.jobId,
        deliveryMethod:
            externalApp.applicantDeliveryMethod === DeliveryMethod.None
                ? DeliveryMethod.Email
                : externalApp.applicantDeliveryMethod,
        tenantId: externalApp.tenantId,
        buId: externalApp.buId,
        requestedAmount: externalApp.amount ?? undefined,
        planNumbers: externalApp.planNumber ? [externalApp.planNumber] : null,
        technicianId: externalApp.technicianId ?? undefined,
        technicianEmail: submittingUser?.email ?? undefined,
        technicianPhone: submittingUser?.phone ?? undefined,
        technicianLastName: submittingUser?.lastName ?? undefined,
        primaryApplicant: externalApp.applicant
            ? {
                  firstName: externalApp.applicant.firstName,
                  lastName: externalApp.applicant.lastName,
                  emailAddress: externalApp.applicant.email,
                  primaryPhone: externalApp.applicant.phone,
                  // Required fields with defaults - these will be collected in the full application
                  dateOfBirth: new Date().toISOString(),
                  monthlyHousingPayment: 0,
                  propertyType: PropertyType.NotSet,
                  housingType: ResidenceOwnership.NotSet,
                  annualIncome: 0,
                  residenceType: ResidenceType.NotSet,
                  employmentStatus: EmploymentStatus.NotSet,
                  citizenship: Citizenship.NotSet,
                  spokenLanguage: SpokenLanguage.NotSet,
              }
            : null,
        address: externalApp.applicant?.address
            ? {
                  street: externalApp.applicant.address.street,
                  address2: externalApp.applicant.address.address2,
                  city: externalApp.applicant.address.city,
                  state: externalApp.applicant.address.state,
                  zip: externalApp.applicant.address.zip,
              }
            : undefined,
        source: externalApp.source as unknown as LoanApplicationSubmitSource,
    };
};
